import { Link, useLocation } from "react-router-dom";
import { useSubscription } from "../context/SubscriptionContext";
import { useMyProviders } from "../context/MyProvidersContext";
import { SignInButton, SignUpButton, UserButton, useUser } from "@clerk/react";

export default function Navbar() {
  const { isPro, isEnterprise, setShowUpgradeModal, setUpgradeMessage } = useSubscription();
  const { filterActive, toggleFilter, lists } = useMyProviders();
  const location = useLocation();
  const isHome = location.pathname === "/";
  const { isSignedIn } = useUser();

  return (
    <header className="sticky top-0 z-40 border-b border-white/8 bg-navy-900/80 backdrop-blur-md">
      <div className="max-w-3xl mx-auto px-4">

        {/* Top row — logo + upgrade */}
        <div className="h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-gold-400 text-lg">◎</span>
            <span className="font-display text-white font-semibold tracking-tight hidden sm:inline">ProviderPayWatch</span>
            <span className="font-display text-white font-semibold tracking-tight sm:hidden">PPW</span>
          </Link>          
          <nav className="flex items-center gap-3">
            {/* Company Search link hidden — mobile spacing issue, can re-enable later */}
            {/* <Link to="/company-search" className="text-white/50 hover:text-white text-sm transition-colors">
              Company Search
            </Link> */}            
            <Link to="/about" className="text-white/50 hover:text-white text-sm transition-colors">
              About
            </Link>
            {isPro && isSignedIn && (
              <Link
                to="/my-providers"
                className={`text-sm transition-colors ${
                  location.pathname === "/my-providers"
                    ? "text-gold-400"
                    : "text-white/50 hover:text-white"
                }`}
              >
                My Providers
                {filterActive && (
                  <span className="ml-1 text-gold-400 text-xs">◉</span>
                )}
              </Link>
            )}
            {isEnterprise && isSignedIn && (
              <Link
                to="/my-vendors"
                className={`text-sm transition-colors ${
                  location.pathname === "/my-vendors"
                    ? "text-gold-400"
                    : "text-white/50 hover:text-white"
                }`}
              >
                My Vendors
              </Link>
            )}
            {isEnterprise && isSignedIn && (
              <Link
                to="/coi-providers"
                className={`hidden md:inline text-sm transition-colors ${
                  location.pathname === "/coi-providers"
                    ? "text-gold-400"
                    : "text-white/50 hover:text-white"
                }`}
              >
                COI
              </Link>
            )}
            {isSignedIn ? (
              <>
                {isEnterprise ? (
                  <span className="badge bg-purple-500/10 border border-purple-500/30 text-purple-300">
                    ✦ Enterprise
                  </span>
                ) : isPro ? (
                  <span className="badge bg-gold-500/10 border border-gold-500/30 text-gold-400">
                    ✦ Pro
                  </span>
                ) : (
                  <button
                    onClick={() => setShowUpgradeModal(true)}
                    className="btn-primary text-sm px-4 py-2"
                  >
                    Upgrade
                  </button>
                )}
                <UserButton afterSignOutUrl="/" />
              </>
            ) : (
              <>
                <SignInButton mode="modal">
                  <button className="text-white/50 hover:text-white text-sm transition-colors">
                    Sign in
                  </button>
                </SignInButton>
                <SignUpButton mode="modal">
                  <button className="btn-primary text-sm px-4 py-2">
                    Sign up
                  </button>
                </SignUpButton>
              </>
            )}
          </nav>          
        </div>

        {/* Search link — hidden on home page */}
        {!isHome && (
          <div className="pb-2 flex justify-center">
            <Link to="/" className="text-white/30 hover:text-white/60 text-xs transition-colors">
              ← Search providers
            </Link>
          </div>
        )}

      </div>
    </header>    
  );
}